// src/components/VoucherPopup.jsx
import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import ReactDOM from "react-dom";

export default function VoucherPopup({ voucherId, onClose }) {
  const [voucher, setVoucher] = useState(null);

  useEffect(() => {
    const fetchVoucher = async () => {
      if (!voucherId) return;
      const snap = await getDoc(doc(db, "vouchers", voucherId));
      if (snap.exists()) setVoucher({ id: snap.id, ...snap.data() });
    };
    fetchVoucher();
  }, [voucherId]);

  if (!voucher) return null;

  const popupContent = (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={onClose} // backdrop click close
    >
      <div
        className="bg-white w-full max-w-3xl rounded-xl shadow-lg p-4"
        onClick={(e) => e.stopPropagation()} // prevent backdrop close
      >
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-2 mb-3">
          <h2 className="text-lg font-semibold">
            Voucher #{voucher.voucherNo} ({voucher.voucherType})
          </h2>
          <button
            onClick={onClose}
            className="text-red-500 hover:text-red-700 font-bold text-xl"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        {/* Voucher Details */}
        <p className="mb-2">📅 Date: {voucher.date}</p>
        <p className="mb-4">📝 Narration: {voucher.narration || "-"}</p>

        {/* Table */}
        <table className="w-full border text-sm mb-4">
          <thead className="bg-gray-100">
            <tr>
              <th className="border p-2">Dr/Cr</th>
              <th className="border p-2">Party</th>
              <th className="border p-2 text-right">Debit</th>
              <th className="border p-2 text-right">Credit</th>
            </tr>
          </thead>
          <tbody>
            {voucher.rows?.map((r, i) => (
              <tr key={i}>
                <td className="border p-2">{r.drcr}</td>
                <td className="border p-2">{r.partyName}</td>
                <td className="border p-2 text-right">{r.debit || "-"}</td>
                <td className="border p-2 text-right">{r.credit || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Footer */}
        <div className="text-right">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );

  // Render with Portal
  return ReactDOM.createPortal(popupContent, document.body);
}
